import { Outlet, Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/auth/AuthContext';
import { AuthBrandMark } from '@/components/auth/AuthBrandMark';
import { AuthPageShell } from '@/components/auth/AuthPageShell';

/**
 * Minimal chrome for the first-run welcome page (no sidebar / bottom nav).
 */
export function WelcomeShell() {
  const { t } = useTranslation('welcome');
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const replayMode = searchParams.get('replay') === '1';
  const showBackLink = replayMode || user?.preference?.hasSeenOnboarding === true;

  return (
    <AuthPageShell>
      <div className="flex min-h-screen flex-col">
        <header className="absolute inset-x-0 top-0 z-20 px-4 py-4 md:px-8">
          <div className="mx-auto flex max-w-6xl items-center justify-between">
            <AuthBrandMark />
            {showBackLink ? (
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 rounded-full bg-background/60 px-3 py-1.5 text-sm font-semibold text-muted-foreground shadow-sm backdrop-blur-md transition-colors hover:text-foreground"
              >
                <ArrowLeft className="h-4 w-4" aria-hidden />
                {t('shell.backToApp')}
              </Link>
            ) : null}
          </div>
        </header>
        <main className="flex-1 overflow-y-auto pt-16">
          <Outlet />
        </main>
      </div>
    </AuthPageShell>
  );
}
